import { render, staticRenderFns } from "./TemaDetalle.vue?vue&type=template&id=32988194&"
import script from "./TemaDetalle.vue?vue&type=script&lang=js&"
export * from "./TemaDetalle.vue?vue&type=script&lang=js&"
import style0 from "./TemaDetalle.vue?vue&type=style&index=0&id=32988194&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports